<template>
  <div class="channel">
    <el-breadcrumb class="breadcrumb">
      <el-breadcrumb-item>财务中心</el-breadcrumb-item>
      <el-breadcrumb-item>渠道管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="search-container">
      <div class="sc-box">
        <span class="title">渠道名称</span>
        <div class="control">
          <el-input placeholder="输入渠道名称" size="small" v-model="searchData.name" clearable>
          </el-input>
        </div>
      </div>
      <div class="sc-box">
        <span class="title">启停用</span>
        <div class="control">
          <el-select v-model="searchData.state" size="small" clearable placeholder="选择启停用">
            <el-option v-for="item in channelStateOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="sc-box">
        <el-button type="primary" size="small" icon="el-icon-search" @click="getList">搜索</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetFrom">重置</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleClickEdit()">新增渠道</el-button>
      </div>
    </div>
    <!-- 搜索 end  -->
    <!-- 列表 -->
    <div class="table-container">
      <div class="tc-table">
        <el-table v-loading="loading" :data="listData" border header-cell-class-name="table-header-cell">
          <el-table-column prop="guid" label="渠道ID"> </el-table-column>
          <el-table-column prop="name" label="渠道名称"> </el-table-column>
          <el-table-column prop="appSecret" label="秘钥"> </el-table-column>
          <el-table-column prop="callBackUrl" label="回调地址">
          </el-table-column>
          <el-table-column label="启停用" width="80">
            <template slot-scope="scope">
              <el-switch @change="handleClickSwitch(scope.row)" :value="scope.row.state"
                :active-value="channelStateOptions[1].value" :inactive-value="channelStateOptions[2].value">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="支持商户" width="100">
            <template slot-scope="scope">
              {{ scope.row.merchantType == 1 ? '全部商户' : '部分商户' }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="handleClickEdit(scope.row)" type="text">修改信息</el-button>
              <el-button v-show="scope.row.merchantType == 2" @click="merchantSet(scope.row)" type="text">商户配置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tc-page">
        <el-pagination background @size-change="e => handleSizeChange(e, 'first')"
          @current-change="e => handleCurrentChange(e, 'first')" :current-page="page.currentPage"
          :page-size="page.pageSize" layout="total, prev, pager, next, sizes, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 列表 end  -->
    <!-- 新增编辑渠道 -->
    <el-dialog :title="modelData.id > 0 ? '编辑渠道' : '新增渠道'" :visible.sync="dialogChannel" custom-class="channel_dialog"
      width="500px" :close-on-click-modal="false">
      <div class="myform">
        <el-form :model="modelData" :rules="rules" ref="channelForm">
          <el-form-item label="渠道名称" prop="name">
            <el-input placeholder="请输入渠道名称" v-model="modelData.name" type="textarea" maxlength="50"
              :autosize="{ minRows: 2, maxRows: 4 }" show-word-limit clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="支持商户" prop="merchantType">
            <el-select v-model="modelData.merchantType" size="small" clearable placeholder="选择商户">
              <el-option v-for="item in merchantOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回调地址">
            <el-input placeholder="回调地址" size="small" clearable v-model="modelData.callBackUrl"></el-input>
          </el-form-item>
          <div class="myform__buts">
            <el-button size="small" @click="reset">取 消</el-button>
            <el-button size="small" type="primary" @click="handleSubmitChannel">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 新增编辑渠道 end -->
    <!-- 商户列表 -->
    <el-dialog title="商户配置" :visible.sync="dialogMerchant" custom-class="channel_dialog" :close-on-click-modal="false">
      <div class="myform">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first">
            <el-table :data="merchantList" border header-cell-class-name="table-header-cell" ref="multipleTable"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="primaryKey" label="商户ID">
              </el-table-column>
              <el-table-column prop="merchantName" label="商户名称">
              </el-table-column>
              <el-table-column prop="companyName" label="所属公司">
              </el-table-column>
            </el-table>
            <div class="tc-page">
              <el-pagination background @size-change="e => handleSizeChange(e, 'second')"
                @current-change="e => handleCurrentChange(e, 'second')" :current-page="merchantParams.currentPage"
                :page-size="merchantParams.pageSize" layout="total, prev, pager, next, sizes, jumper"
                :total="merchantTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已分配商户" name="second">
            <el-table :data="assignedMerchantList" border header-cell-class-name="table-header-cell"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"> </el-table-column>

              <el-table-column prop="primaryKey" label="商户ID">
              </el-table-column>
              <el-table-column prop="merchantName" label="商户名称">
              </el-table-column>
              <el-table-column prop="companyName" label="所属公司">
              </el-table-column>
            </el-table>
            <div class="tc-page">
              <el-pagination background @size-change="e => handleSizeChange(e, 'third')"
                @current-change="e => handleCurrentChange(e, 'third')" :current-page="assignedMerchantParams.currentPage"
                :page-size="assignedMerchantParams.pageSize" layout="total, prev, pager, next, sizes, jumper"
                :total="assignedMerchantTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="myform__buts">
          <el-button size="small" @click="resetMultipleSelection">取 消</el-button>
          <el-button size="small" type="primary" @click="handleMultipleSelection">{{ butName }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 商户列表  -->
  </div>
</template>

<script>
import { PAGESIZE } from '@/utils/constant.js'
import {
  channelList,
  channelAdd,
  channelDetail,
  channelUpdate,
  merchantList,
  listByChannelId,
  merchantBatchCreate,
  merchantBatchDelete
} from '@/api/menu/index.js'

export default {
  components: {},
  name: '',
  data() {
    const url = (rule, value, callback) => {
      let reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
      if (value && reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入有效的链接地址'))
      }
    }
    return {
      butName: '确 定',
      total: 100, // 记录总数
      page: {
        pageSize: PAGESIZE, // 每页条数
        currentPage: 1 // 当前页
      },
      loading: false,
      listData: [
        // 数据集合
      ],
      channelStateOptions: [
        // 停启用状态
        { label: '全部', value: 0 },
        { label: '启用', value: 1 },
        { label: '停用', value: 2 }
      ],
      merchantOptions: [
        { label: '全部商户', value: 1 },
        { label: '部分商户', value: 2 }
      ],
      searchData: {
        // 查询对象
        name: null,
        state: 0
      },
      dialogChannel: false, // 新增编辑弹窗
      dialogMerchant: false,
      modelData: {
        // 渠道对象
        name: '',
        callBackUrl: '',
        merchantType: 1
      },
      guid: null,
      rules: {
        name: [{ required: true, message: '请输入渠道名称', trigger: 'blur' }],
        callBackUrl: [
          {
            required: true,
            message: '请输入回调地址',
            validator: url,
            trigger: 'change'
          }
        ],
        merchantType: [
          { required: true, message: '请选择商户', trigger: 'change' }
        ]
      },

      isCreate: false,
      activeName: 'first',
      multipleSelection: [],
      merchantList: [],
      merchantParams: {
        currentPage: 1,
        pageSize: PAGESIZE
      },
      merchantTotal: 0,
      assignedMerchantParams: {
        channelId: null,
        pageSize: PAGESIZE, // 每页条数
        currentPage: 1 // 当前页
      },
      assignedMerchantList: [],
      assignedMerchantTotal: 0
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() {
    this.getList()
    this.getMerchantData()
  },
  methods: {
    //获取列表
    getList() {
      this.loading = true
      let state = null
      if (this.searchData.state !== 0) {
        state = this.searchData.state
      }
      channelList({ ...this.page, ...this.searchData, state }).then(res => {
        this.loading = false
        this.listData = res.data.result.records
        this.total = res.data.result.total
      })
    },
    // 提交渠道信息
    handleSubmitChannel() {
      this.$refs.channelForm.validate(valid => {
        if (valid) {
          //新增
          if (this.isCreate) {
            channelAdd(this.modelData).then(res => {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getList()
            })
          } else {
            //编辑
            channelUpdate({ ...this.modelData, guid: this.guid }).then(res => {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getList()
            })
          }
          this.dialogChannel = false
        } else {
          return false
        }
      })
    },
    // pageSize 改变时会触发
    handleSizeChange(e, value) {
      console.log(value)
      //列表
      if (value == 'first') {
        this.page.pageSize = e
        this.getList()
      }
      //全部商户列表
      if (value == 'second') {
        this.merchantParams.pageSize = e
        this.getMerchantData()
      }
      //已分配的商户列表
      if (value == 'third') {
        this.assignedMerchantParams.pageSize = e
        this.getListByChannelId()
      }
    },
    // currentPage 改变时会触发
    handleCurrentChange(e, value) {
      //列表
      if (value == 'first') {
        this.page.currentPage = e
        this.getList()
      }
      //全部商户列表
      if (value == 'second') {
        this.merchantParams.currentPage = e
        this.getMerchantData()
      }
      //已分配的商户列表
      if (value == 'third') {
        this.assignedMerchantParams.currentPage = e
        this.getListByChannelId()
      }
    },
    // 点击修改信息
    handleClickEdit(row) {
      this.dialogChannel = true
      if (row) {
        this.isCreate = false
        this.guid = row.guid
        this.itemDetail(row)
      } else {
        this.isCreate = true
        this.modelData = {
          // 渠道对象
          name: '',
          callBackUrl: '',
          merchantType: 1
        }
      }
    },
    itemDetail(row) {
      channelDetail({ guid: row.guid }).then(res => {
        let data = res.data.result
        Object.keys(this.modelData).forEach(key => {
          this.modelData[key] = data[key]
        })
      })
    },
    // 切换启停用
    handleClickSwitch(row) {
      let state = null
      let text = null
      if (row.state == 1) {
        state = 2
        text = '停用'
      } else {
        state = 1
        text = '启用'
      }
      this.$confirm(`此操作将修改成${text}状态, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          channelUpdate({ guid: row.guid, state }).then(res => {
            this.$message({
              type: 'success',
              message: `已${state == 2 ? '停用' : '启用'}`
            })
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    //点击商户配置
    merchantSet(row) {
      this.dialogMerchant = true
      this.assignedMerchantParams.channelId = row.guid
      this.getListByChannelId()
    },
    //商户配置弹窗
    merchantSelect(val) {
      if (val == 2) {
        this.getMerchantData()
        this.dialogMerchant = true
      }
    },
    //已分配商户列表
    getListByChannelId() {
      listByChannelId(this.assignedMerchantParams).then(res => {
        this.assignedMerchantList = res.data.result.records
        this.assignedMerchantTotal = res.data.result.total
      })
    },
    handleClick(e) {
      this.resetPageSizeAndCurrent()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //重置
    resetFrom() {
      this.searchData = {
        channelName: '',
        state: 0
      }
    },
    //重置表单提交校验结果
    resetFieldsForm() {
      this.$refs.channelForm.resetFields()
      this.dialogChannel = false
    },
    //重置商户列表
    resetMultipleSelection() {
      this.multipleSelection = []

      this.$refs.multipleTable.clearSelection()
      this.dialogMerchant = false
    },
    //获取商户列表
    getMerchantData() {
      merchantList(this.merchantParams).then(res => {
        this.merchantList = res.data.result.records
        this.merchantTotal = res.data.result.total
      })
    },
    handleMultipleSelection() {
      if (this.multipleSelection.length > 0) {
        if (this.activeName == 'first') {
          merchantBatchCreate({
            list: this.resetMerchantIds()
          }).then(res => {
            this.$message({
              type: 'success',
              message: '商户分配成功'
            })
            this.getListByChannelId()
            this.activeName = 'second'
          })
        } else {
          merchantBatchDelete({
            guid: this.assignedMerchantParams.channelId,
            guids: this.resetMerchantIds()
          }).then(res => {
            this.$message({
              type: 'success',
              message: '取消商户成功'
            })
          })
          this.getListByChannelId()
        }
      }
      // this.dialogMerchant = false
    },
    resetMerchantIds() {
      let ary = []
      this.multipleSelection.forEach(item => {
        if (this.activeName == 'first') {
          let obj = {
            merchantId: item.primaryKey,
            channelId: this.assignedMerchantParams.channelId
          }
          ary.push(obj)
        } else {
          ary.push(item.channelMerchantId)
        }
      })
      return ary
    },
    resetPageSizeAndCurrent() {
      if (this.activeName == 'first') {
        this.butName = '确 定'
        this.merchantParams = {
          currentPage: 1,
          pageSize: PAGESIZE
        }
        this.getMerchantData()
      } else {
        this.butName = '取消分配'
        this.assignedMerchantParams.currentPage = 1
        this.assignedMerchantParams.pageSize = PAGESIZE
        this.getListByChannelId()
      }
    },
    reset() {
      this.dialogChannel = false
      this.$refs.channelForm.resetFields()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/css/variables.scss';
@import '@/assets/css/mixin';
@import '@/assets/css/pay';

.channel {
  padding: $outerPadding;
  @include search;
  @include table_container;
}

.myform {
  border-top: 0.01rem solid $hrColor;
  padding: $outerPadding 0.5rem;

  ::v-deep {
    .el-form-item__content {
      display: flex;
    }

    .el-form-item__label {
      font-weight: 400;
    }
  }

  &__buts {
    margin-top: 0.4rem;
  }
}

::v-deep {
  .el-dialog__body {
    padding: 0;
  }

  .el-form-item__label {
    width: 90px;
  }
}

.tc-page {
  padding-top: 10px;
}
</style>
